<template>
  <li class="nav-item active">
    <router-link
      v-if="!auth"
      class="link-login ub-link nav-link d-none d-lg-block"
      to="/signin"
    >Sign in</router-link>

    <div v-else :class="pageClass + ' dropdown d-none d-lg-block'">
      <router-link to="/app" class="ub-link nav-link" replace>
        {{ username }}&nbsp;
        <span id="planBox">{{ userPlan || getWindowLocalStorage("userPlan") }}</span>
        <DirectionArrow></DirectionArrow>
      </router-link>

      <div class="dropdown-content">
        <router-link to="/app">Account</router-link>
        <router-link v-if="role == 'free'" id="upgradeLink" to="/upgrade">Upgrade Now - Go Premium</router-link>

        <p
          id="logout"
          @click="toLogout"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
        >Sign out</p>
      </div>
    </div>

    <!-- mobile -->
    <router-link
      v-if="!auth"
      class="lnk-login ub-link nav-link d-sm-block d-md-block d-lg-none"
      to="/signin"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
    >Sign in</router-link>

    <router-link
      v-else
      class="link-login ub-link nav-link d-sm-block d-md-block d-lg-none"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      to="/app"
      replace
    >{{ username }}</router-link>
  </li>
</template>

<script>
import DirectionArrow from "@/components/utils/direction-arrow";
import { mapState, mapGetters } from "vuex";

export default {
  name: "NavbarMenuAuthItem",

  components: {
    DirectionArrow
  },

  props: {
    pageClass: {
      type: String,
      default: "black-navbar"
    }
  },

  computed: {
    auth() {
      return this.isLogin && this.getWindowLocalStorage("token");
    },

    username() {
      // const first =
      //   this.firstname.substr(0, 1).toUpperCase() + this.firstname.substr(1);
      // const last =
      //   this.lastname.substr(0, 1).toUpperCase() + this.lastname.substr(1);
      // const name = first + " " + last;
      // return name.length > 25 ? name.substr(0, 22) + "..." : name;
      const first =
        this.firstname.substr(0, 1).toUpperCase() + this.firstname.substr(1);
      return first.length > 25 ? first.substr(0, 22) + "..." : first;
    },

    role() {
      return this.getWindowLocalStorage("role");
    },

    ...mapState({
      firstname: state => state.UserService.userFirstName,
      lastname: state => state.UserService.userLastName
    }),
    ...mapGetters(["isLogin", "userPlan"])
  },

  methods: {
    toLogout() {
      // console.log("1. Store dispatch: logout");
      this.$store.dispatch("logout");
      // console.log("2. Send Notify");
      this.$notify({
        group: "note",
        title: "UniBit Account",
        text: "Successfully logged out",
        type: "success"
      });
      // console.log("3. Login");
      this.$router.replace("/signin");
    }
  }
};
</script>

<style scoped>
.black-navbar {
  background: #1b2e38;
  color: white;
}

.white-navbar {
  background: transparent;
  color: black;
}

.white-navbar .ub-link {
  color: black;
}

.black-navbar .ub-link {
  color: white;
}

#planBox {
  display: inline-block;
  padding: 0.2rem 0.3rem;

  font-size: 0.8rem;
  font-weight: bold;
  line-height: 10px;
  vertical-align: text-bottom;
  border-radius: 4px;
  border: 1px solid;
}

.white-navbar #planBox {
  color: white;
  border-color: black;
  background-color: black;
}

.black-navbar #planBox {
  color: black;
  border-color: white;
  background-color: white;
}

#upgradeLink {
  font-weight: bold;
  color: #f5a623;
  border-bottom: solid 0.4px;
}

.white-navbar #upgradeLink {
  border-bottom-color: black;
}

.black-navbar #upgradeLink {
  border-bottom-color: white;
}

.link-login {
  color: #16a8bd !important;
  cursor: pointer;
}

.link-login:hover {
  text-decoration: underline;
}

/* ---------------------------------------------------
  dropdown content styling
----------------------------------------------------- */
.dropdown {
  position: relative;
  cursor: pointer;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  top: 2.5rem;
  right: 0.5rem;

  width: 10rem;
  min-width: 8rem;
  text-align: left;

  border-radius: 4px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

/* Links inside the dropdown */
.dropdown-content a,
.dropdown-content p {
  font-size: 1rem;
  text-decoration: none;
  padding: 0.4rem 1rem;
  cursor: pointer;
}

.white-navbar .dropdown-content {
  background-color: white;
}

.white-navbar .dropdown-content a {
  color: black;
}

.black-navbar .dropdown-content a {
  color: white;
}

.black-navbar .dropdown-content {
  background-color: #1b2e38;
}

.white-navbar .dropdown-content a:hover,
.white-navbar .dropdown-content p:hover {
  background-color: #ebebeb;
}

.black-navbar .dropdown-content a:hover,
.black-navbar .dropdown-content p:hover {
  background-color: #37a8bd;
}

@media (min-width: 992px) {
  /* Show the dropdown menu on hover */
  .dropdown:hover .dropdown-content {
    display: flex;
    flex-direction: column;
  }
}

@media (min-width: 1200px) {
}
</style>


// WEBPACK FOOTER //
// src/components/fixed/navbar/navbar-menu-auth-item.vue